function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "\\uAD6C\\uC131 \\uC694\\uC18C 343 \\u2013 8",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 154606",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.952-780.1a9.605 9.605 0 0 1-7.06-2.892 9.6 9.6 0 0 1-2.892-7.06 9.6 9.6 0 0 1 2.892-7.06 9.605 9.605 0 0 1 7.06-2.892 9.848 9.848 0 0 1 4.105.886 9.481 9.481 0 0 1 3.359 2.535V-800h2.484v8.708h-8.7v-2.488h5.225a7.26 7.26 0 0 0-2.721-2.737 7.373 7.373 0 0 0-3.747-1 7.2 7.2 0 0 0-5.287 2.177 7.2 7.2 0 0 0-2.177 5.287 7.2 7.2 0 0 0 2.177 5.287 7.2 7.2 0 0 0 5.287 2.177 7.291 7.291 0 0 0 4.323-1.368 7.225 7.225 0 0 0 2.706-3.607h2.612a9.821 9.821 0 0 1-3.545 5.38 9.651 9.651 0 0 1-6.101 2.084z",
    transform: "translate(-157.952 802.048)",
    style: {
      fill: "#121212"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.df058e174699326177a50972ff75b7b6.svg";
export { ForwardRef as ReactComponent };